import { render, staticRenderFns } from "./RamsStatusPanel.vue?vue&type=template&id=07080bb9&"
import script from "./RamsStatusPanel.vue?vue&type=script&lang=js&"
export * from "./RamsStatusPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports